import { types } from '../types/types';

const initialState = {
    uid: null,
    displayName: null,
    email: null,
    photoURL: null,
    accessToken: null,
    hashtag: null,
    nombre: null,
    zonaHoraria: null,
    ladaPais: null,
    onboardingCompleto: false,
    suscripcionActiva: false,
};

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.login:
            return { ...state, ...action.payload };
        case types.logout:
            return initialState;
        case types.authUpdateEmpresa:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
